export * from "./ToteBetsApiBetDeclineReason";
//# sourceMappingURL=index.js.map